import React from 'react';
import DijonCard from './DijonCard';
import DijonVideos from './DijonVideos';

function DijonVideosCard(props) {
  return (
    <DijonCard
      title="Video Library"
      icon="video"
      activeCards={props.activeCards}
      setActiveCards={props.setActiveCards}
      fullscreen={props.fullscreen}
      setFullscreen={props.setFullscreen}
      name="videos"
      content={<DijonVideos />}
    />
  );
}

export default DijonVideosCard;